import React, { useState, useEffect } from "react";
import { TextField, Button, InputAdornment, IconButton } from "@mui/material";
import "./Home.css";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Layout from "../Layout";

function Home({
  searchQuery,
  setSearchQuery,
  handleSearch,
  selectedDb,
  setSelectedDb,
}) {
  let sampleQuestions;
  let dbDiagramLink;

  if (selectedDb === "Store") {
    sampleQuestions = [
      "what is the name of the most expensive product?",
      "how many female(F) customers do we have from the state of Oregon (OR) and New York (NY)?",
      "what is the total amount of salaries paid?",
      "who over 88 has an income of over 99999?",
    ];
    dbDiagramLink = "/store";
  } else if (selectedDb === "Employee") {
    sampleQuestions = [
      "How many Departments are there in the company?",
      "How many employees are working for the company?",
      "What is the name of the department that employee 10004 works in?",
      "What title does employee 10008 have?",
    ];

    dbDiagramLink = "/employee";
  }

  const [questionClicked, setQuestionClicked] = useState(false);
  useEffect(() => {
    const baseUrl =
      process.env.NODE_ENV === "production"
        ? "https://server-sqltranslated.onrender.com"
        : "http://localhost:5000/";
    // Send an HTTP request to keep the server active every 3 minutes
    const intervalId = setInterval(() => {
      fetch(`${baseUrl}`)
        .then((response) => {
          // Do nothing with the response
        })
        .catch((error) => {
          console.error("Error sending ping request:", error);
        });
    }, 200000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const sendToSearch = (question) => {
    setSearchQuery(question);
    setQuestionClicked(true);
  };
  useEffect(() => {
    if (questionClicked) {
      handleSearch(selectedDb);
      setQuestionClicked(false);
    }
  }, [handleSearch, questionClicked, selectedDb]);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(dbDiagramLink);
  };
  return (
    <Layout>
      <div className="FlexRow">
        <div className="SubHeader">Search Like a Pro</div>
        <div className="BetaText">BETA</div>
      </div>
      <div className="HeaderTitle">New Era Technologies</div>
      <div className="SubHeaderText">Translating Natural Language to SQL.</div>
      <br />
      <div className="SearchContainer">
        <TextField
          id="ppl-query-input"
          placeholder="Query the Database in Natural Language?"
          variant="outlined"
          fullWidth
          className="SearchInput"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery.length > 0 && (
                  <IconButton onClick={() => setSearchQuery("")}>
                    <ClearIcon />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />

        <Button
          onClick={() => handleSearch(selectedDb)}
          variant="contained"
          className="SearchBtn"
        >
          <SearchIcon fontSize="large" />
        </Button>
      </div>

      <div className="DoubleGrid">
        {sampleQuestions.map((question, index) => (
          <div
            key={index}
            onClick={() => sendToSearch(question)}
            className="SampleItem"
          >
            {question}
          </div>
        ))}
      </div>
      <div className="DbDiagram">
        <Button onClick={handleNavigate}>DB Diagram</Button>
      </div>
    </Layout>
  );
}

export default Home;
